export default {"src":"/_next/static/media/zen-it-icon.7cb8ee0f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};